import React from 'react';
import { Card, CardContent, Grid, Typography } from '@material-ui/core';
import Image from '../common/Image';

export default function JourneyCardItem({ journey, classes, journeyFromText }) {
  return (
    <Card
      style={{
        width: '100%',
        borderRadius: '8px',
        height: '120px',
      }}
    >
      <CardContent>
        <Grid container direction="column">
          <Grid item>
            <Grid container direction="row">
              <Grid item xs={4}>
                <Image alt={journey.id} src={journey.thumbnail} className={classes.journeyThumbnail} />
              </Grid>
              <Grid item xs={8}>
                <Grid container direction="column">
                  <Grid item xs={2}>
                    <Typography className={classes.primaryText}> {journey.title}</Typography>
                  </Grid>
                  <Grid item xs={8}>
                    {' '}
                    <br />{' '}
                  </Grid>
                  <Grid item xs={2}>
                    <Typography className={classes.secondaryText}> {journey.publishDate}</Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <Grid container direction="row" style={{ marginTop: '10px' }}>
              {journey.mandatory ? (
                <Grid item className={classes.mandatoryBox}>
                  <span className={classes.mandatoryText}>Mandatory</span>
                </Grid>
              ) : null}
              {journey.journeyFrom?.map((j) => (
                <Grid item className={classes.journeyFromBox} key={j}>
                  {journeyFromText(j, journey)}
                </Grid>
              ))}
            </Grid>
          </Grid>
          <span className={classes.bottom}></span>
        </Grid>
      </CardContent>
    </Card>
  );
}
